import { createContext } from "react";

const DF_OT0019Context = createContext();

export { DF_OT0019Context };